import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/main-engine/main-engine.js';
      import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';

      export interface Props {
     thrust?: number;
     thrustSetpoint?: number | undefined;
     thrustTouching?: boolean;
     atThrustSetpoint?: boolean;
     speed?: number;
     speedSetpoint?: number | undefined;
     speedTouching?: boolean;
     atSpeedSetpoint?: boolean;
     autoAtThrustSetpoint?: boolean;
     autoAtSpeedSetpoint?: boolean;
     autoAtThrustSetpointDeadband?: number;
     autoAtSpeedSetpointDeadband?: number;
     thrustSetpointAtZeroDeadband?: number;
     speedSetpointAtZeroDeadband?: number;
     state?: InstrumentState;
     priority?: Priority;
     thrustAdvices?: LinearAdvice[]
   }

      
  
      export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcMainEngine',
  props: {
    thrust: {},
    thrustSetpoint: {},
    thrustTouching: { type: Boolean },
    atThrustSetpoint: { type: Boolean },
    speed: {},
    speedSetpoint: {},
    speedTouching: { type: Boolean },
    atSpeedSetpoint: { type: Boolean },
    autoAtThrustSetpoint: { type: Boolean },
    autoAtSpeedSetpoint: { type: Boolean },
    autoAtThrustSetpointDeadband: {},
    autoAtSpeedSetpointDeadband: {},
    thrustSetpointAtZeroDeadband: {},
    speedSetpointAtZeroDeadband: {},
    state: {},
    priority: {},
    thrustAdvices: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-main-engine',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})